import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { iconColor } from 'utils/helpers'

export const ShrinkIcon = () => {
    const { darkMode } = useSelector((state: RootState) => state.globals)
    const fill = iconColor(darkMode)
    return <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.202236 9.16235C-0.0674119 9.42708 -0.0674119 9.8563 0.202236 10.121C0.471883 10.3858 0.909069 10.3858 1.17872 10.121L5.32157 6.05369C5.59122 5.78896 5.59122 5.35974 5.32157 5.09501L1.17872 1.02767C0.90907 0.762938 0.471884 0.762938 0.202237 1.02767C-0.0674111 1.2924 -0.0674112 1.72162 0.202237 1.98635L3.85685 5.57435L0.202236 9.16235Z" fill={fill} />
    </svg>


}


